import { NavigationGuardNext, RouteLocationNormalized } from 'vue-router';
import { storage } from '@/utils/storage';
import { projectName } from '@/utils/config';

export default [
  {
    path: '/IFPageOneHThirtyTwoPreLogin',
    name: 'IFPageOneHThirtyTwoPreLogin',
    meta: {
      title: projectName,
    },
    component: () => import('@/pages/pageListAll/pageOneHThirtyTwo/preLogin.vue'),
    beforeEnter: (
      to: RouteLocationNormalized,
      from: RouteLocationNormalized,
      next: NavigationGuardNext
    ) => {
      /* 20230727 返回拦截下载页 */
      if (
        from.path === '/IFPageOneHThirtyTwoLogin' ||
        from.path === '/IFPageOneHThirtyTwoLoginSecond'
      ) {
        window.history.back();
      } else {
        next();
      }
    },
  },
  {
    path: '/IFPageOneHThirtyTwoLogin',
    name: 'pageOneHThirtyTwoLogin',
    meta: {
      title: projectName,
    },
    component: () => import('@/pages/pageListAll/pageOneHThirtyTwo/login.vue'),
  },
  {
    path: '/IFPageOneHThirtyTwoLeaveInfo',
    name: 'pageOneHThirtyTwoLeaveInfo',
    meta: {
      title: projectName,
    },
    component: () => import('@/pages/pageListAll/pageOneHThirtyTwo/leaveInfo.vue'),
  },
  {
    path: '/IFPageOneHThirtyTwoResult',
    name: 'pageOneHThirtyTwoResult',
    meta: {
      title: projectName,
    },
    component: () => import('@/pages/pageListAll/pageOneHThirtyTwo/result.vue'),
  },
  {
    path: '/IFPageOneHThirtyTwoLoading',
    name: 'pageOneHThirtyTwoLoading',
    component: () => import('@/pages/pageListAll/pageOneHThirtyTwo/loading.vue'),
    meta: {
      title: '额度检测',
    },
  },
  {
    path: '/IFPageOneHThirtyTwoLoginSecond',
    name: 'pageOneHThirtyTwoLoginSecond',
    component: () => import('@/pages/pageListAll/pageOneHThirtyTwo/loginSecond.vue'),
    meta: {
      title: projectName,
    },
  },
  {
    path: '/IFPageOneHThirtyTwoOnline',
    name: 'pageOneHThirtyTwoOnline',
    component: () => import('@/pages/pageListAll/pageOneHThirtyTwo/online.vue'),
    meta: {
      title: projectName,
    },
    beforeEnter: (
      to: RouteLocationNormalized,
      from: RouteLocationNormalized,
      next: NavigationGuardNext
    ) => {
      /* 网贷来源页 */
      if (from.path == '/IFPageOneHThirtyTwoLoginSecond') {
        storage.setItem('onlineGoApply', null);
      } else {
        to.query.time = `${new Date().getTime()}`;
      }
      next();
    },
  },
  {
    path: '/IFPageOneHThirtyTwoGuide',
    name: 'pageOneHThirtyTwoLoginGuide',
    component: () => import('@/pages/pageListAll/pageOneHThirtyTwo/guide.vue'),
    meta: {
      title: projectName,
    },
    beforeEnter: (
      to: RouteLocationNormalized,
      from: RouteLocationNormalized,
      next: NavigationGuardNext
    ) => {
      to.query.formUrl = from.path;
      next();
    },
  },
  {
    path: '/IFPageOneHThirtyTwoCar',
    name: 'pageOneHThirtyTwoCar',
    component: () => import('@/pages/pageListAll/pageOneHThirtyTwo/car.vue'),
    meta: {
      title: '补充留资',
    },
  },
  {
    path: '/IFPageOneHThirtyTwoCarDetails',
    name: 'pageOneHThirtyTwoCarDetails',
    component: () => import('@/pages/pageListAll/pageOneHThirtyTwo/carDetails.vue'),
    meta: {
      title: '申请结果',
    },
  },
  {
    path: '/IFPageOneHThirtyTwoBlank',
    name: 'pageOneHThirtyTwoBlank',
    component: () => import('@/pages/pageListAll/pageOneHThirtyTwo/blank.vue'),
    meta: {
      title: projectName,
    },
  },
  {
    path: '/IFPageOneHThirtyTwoOnlineTab',
    name: 'pageOneHThirtyTwoOnlineTab',
    component: () => import('@/pages/pageListAll/pageOneHThirtyTwo/onlineTab.vue'),
    meta: {
      title: projectName,
    },
  },
];
